export default __webpack_public_path__ + "static/media/fw-lily-er-White Gold.f548bffa.mp4";